module.exports = __webpack_public_path__ + "img/Forgot-password-pana.feb31376.svg";